import { Button, ButtonGroup } from '@zocdoc/components/src/button';
import { Dropdown, DropdownContainer } from '@zocdoc/components/src/dropdown';
import { breakpoint } from '@zocdoc/components/src/grid';
import { linkStyle } from '@zocdoc/components/src/link';
import { Modal, ModalBodyCopy, ModalButtonContainer, ModalHeader } from '@zocdoc/components/src/modal';
import { find, intersectionBy, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { procedureShape } from '../../../../constants';
import { LOCALIZED_FIND_A_DOCTOR, LOCALIZED_PLEASE_SELECT, LOCALIZED_REFINE_PROCEDURE_TEXT } from '../constants';

class BaseRefineProcedureModal extends PureComponent {
    state = {
        doesProviderPerformProcedure: true,
        selectedProcedure: '',
    };

    static propTypes = {
        additionalMessage: PropTypes.string,
        header: PropTypes.string,
        message: PropTypes.string,
        onClickCancel: PropTypes.func,
        onClickSecondaryAction: PropTypes.func,
        primaryActionHref: PropTypes.string,
        primaryActionText: PropTypes.string,
        procedureLoading: PropTypes.bool,
        procedures: PropTypes.arrayOf(procedureShape),
        provider: PropTypes.object,
        secondaryActionText: PropTypes.string,
        updateParameters: PropTypes.func,
    }

    onClickFindDoctor = event => {
        event.preventDefault();
        this.props.updateParameters({ procedure_id: this.state.selectedProcedure });
    }

    onDropdownChange = procedureId => {
        const selectedProcedure = find(this.props.procedures, { id: procedureId }).name;

        const doesProviderPerformProcedure = Boolean(find(this.props.provider.procedures, { id: procedureId }));

        this.setState({
            doesProviderPerformProcedure,
            selectedProcedure,
        });
    }

    renderAdditionalMessage() {
        if (this.state.doesProviderPerformProcedure) {
            return undefined;
        }

        const { intl } = this.props;

        return (
            <div>
                <ModalBodyCopy>
                    {intl.formatMessage(LOCALIZED_REFINE_PROCEDURE_TEXT.ADDITIONAL_MESSAGE, {
                        provider: this.props.provider.approvedFullName,
                        procedure: this.state.selectedProcedure,
                    })}
                </ModalBodyCopy>
                <ModalBodyCopy>
                    <StyledButton onClick={this.onClickFindDoctor}>
                        {intl.formatMessage(LOCALIZED_FIND_A_DOCTOR.DEFAULT, {
                            procedure: this.state.selectedProcedure,
                        })}
                    </StyledButton>
                </ModalBodyCopy>
            </div>
        );
    }

    render() {
        const {
            intl,
            procedures,
            provider,
        } = this.props;

        /**
         * find me only procedures that the provider performs and that are in the given specialty
         */
        const validProcedures = intersectionBy(procedures, provider.procedures, 'id');

        /**
         * some procedures are all uppercase which screws up the sort order
         */
        const alphaSortedProcedures = orderBy(validProcedures, x => x.name.toLowerCase());

        return (
            <Modal onClickCancel={this.props.onClickCancel}>
                <div>
                    <ModalHeader>{this.props.header}</ModalHeader>
                    <ModalBodyCopy>{this.props.message}</ModalBodyCopy>

                    <DropdownContainer onChange={this.onDropdownChange} >
                        <Dropdown
                            options={alphaSortedProcedures}
                            placeholder={intl.formatMessage(LOCALIZED_PLEASE_SELECT.DEFAULT)}
                        />
                    </DropdownContainer>

                    {this.renderAdditionalMessage()}

                    <ModalButtonContainer>
                        <StyledButtonGroup>
                            <Button
                                data-uem-id="refine-procedure-modal-ok"
                                disabled={!this.state.doesProviderPerformProcedure}
                                fluid
                                href={this.props.primaryActionHref}
                            >
                                {this.props.primaryActionText}
                            </Button>
                            <Button
                                data-uem-id="refine-procedure-modal-cancel"
                                fluid
                                onClick={this.props.onClickSecondaryAction}
                                style={Button.STYLE.TRANSPARENT}
                            >
                                {this.props.secondaryActionText}
                            </Button>
                        </StyledButtonGroup>
                    </ModalButtonContainer>
                </div>
            </Modal>
        );
    }
}

const StyledButtonGroup = styled(ButtonGroup)`
    ${breakpoint.small} {
        display: flex;
    }
`;

const StyledButton = styled.button`
    ${linkStyle};
`;

export default injectIntl(BaseRefineProcedureModal);
